<template>
    <c-input-element 
        class="c-form-element__checkbox" 
        :label="label" 
        :class="[
            { 'c-form-element--horizontal' : horizontal },
            { 'no-margin' : noMargin }
        ]"
        :name="$attrs.name"
        >

        <div class="c-form-checkbox" :class="{'c-form-checkbox--block' : block }">
            <div class="c-form-checkbox__option" v-for="(option,index) in options" :key="'option' + name + index">
                <input
                    type="checkbox"
                    v-model="value"
                    :required="required"
                    :value="getName(option, ValueName)"
                    :id="name + '-' + index + '-' + $.uid"
                />
                <label :for="name + '-' + index + '-' + $.uid">
                    <div class="c-form-checkbox__label-text">{{getName(option, labeltext)}}</div>
                </label>
            </div>
        </div>

    </c-input-element>
</template>

<script>
import Input from '@mixins/Input';
import Helpers from '@support/Helpers';

export default {
    name: 'form-checkbox-input',
    inheritAttrs: false,
    mixins: [Input],
    props: {
        options: {
            required: true
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        block: {
            type: Boolean,
            default: false
        },
        horizontal: {
            type: Boolean,
            default: false
        },
        noMargin: {
            type: Boolean,
            default: false
        },
        name: {
            type:String,
            default: () => Helpers.uid()
        },
        labeltext: {
            type: String,
            default: 'name'
        },
        ValueName: {
            type: String,
            default: 'id'
        }
    },
    methods: {
        getName(option, labeltext){
            if (!labeltext) return option;
            return labeltext
            .split(',')
            .map(key => key.trim())
            .map(key =>
                key
                    .split('.')
                    .reduce((data, keyPart) =>
                        data instanceof Object && keyPart in data ? data[keyPart] : null, option
                    ) ?? ''
            )
            .join(' ');
			
        }

       
			
    },
}
</script>
